export default "__VITE_ASSET__BG7lLRIw__"